import { Box } from '@material-ui/core';

import { ProgressStepStatus } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/entities/Progress/_shared/types';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface StepStatusIconProps {
  stepStatus: ProgressStepStatus;
}

export const StepStatusIcon = ({ stepStatus }: StepStatusIconProps) => {
  const { palette } = useCustomTheme();

  const IconFuture = <Box height={'8px'} width={'8px'} mx={'4px'} borderRadius={'50%'} bgcolor={palette.grey[300]} />;
  const IconPending = (
    <i className={'material-icons-outlined'} style={{ fontSize: 16, color: palette.grey[600] }}>
      hourglass_empty
    </i>
  );
  const IconCompleted = (
    <i className={'material-icons-outlined'} style={{ fontSize: 16, color: palette.success.main }}>
      check
    </i>
  );
  const IconNonActive = (
    <i className={'material-icons-outlined'} style={{ fontSize: 16, color: palette.grey[800] }}>
      close
    </i>
  );

  const getIconByStepStatus = () => {
    switch (stepStatus) {
      case 'completed':
        return IconCompleted;
      case 'future':
        return IconFuture;
      case 'pending':
        return IconPending;
      case 'cancelled':
        return IconNonActive;
      default:
        return IconFuture;
    }
  };

  return (
    <Box display={'flex'} mr={1}>
      {getIconByStepStatus()}
    </Box>
  );
};
